export default function LandingPage() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-slate-50 text-slate-900">
      <div className="text-center px-6">
        <h1 className="text-4xl font-bold text-emerald-600 mb-3">QR Menu</h1>
        <p className="text-slate-600">
          Scan a QR code to view your restaurant&apos;s menu.
        </p>
      </div>
    </main>
  )
}
